import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60493310"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title"
}

import { useRoute } from 'vue-router'
import { computed, ref } from 'vue'
import { useStoryblok } from '@storyblok/vue'
import { modalController } from '@ionic/vue'

import News from '@/models/News'
import Modal from '@/components/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsDetail',
  props: {
    slug: null,
    data: null
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props as {
  slug?: string
  data?: News
};


const route = useRoute()
const { id } = route.params
const story = props.data
  ? ref(null)
  : (
  ([__temp,__restore] = _withAsyncContext(() => useStoryblok(`news/${id || props.slug || ''}`, {
      version: process.env.NODE_ENV === 'production' ? 'published' : 'draft',
    }))),
  __temp = await __temp,
  __restore(),
  __temp
)

const source = computed<News>(() => {
  if (props.data) return props.data
  else return new News(story.value)
})

const close = () => {
  return modalController.dismiss()
}

return (_ctx: any,_cache: any) => {
  const _component_StoryblokComponent = _resolveComponent("StoryblokComponent")!

  return (_openBlock(), _createBlock(Modal, {
    class: _normalizeClass(["modal", { 'is-homepage': _unref(source).isHomepage }]),
    image: _unref(source).picture,
    "no-close": _unref(source).isHomepage,
    onClose: close
  }, {
    default: _withCtx(() => [
      (!_unref(source).isHomepage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h1", null, _toDisplayString(_unref(source).title), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, _toDisplayString(_unref(source).perex), 1),
      (_unref(source).blocks)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(source).blocks, (blok, i) => {
            return (_openBlock(), _createBlock(_component_StoryblokComponent, {
              key: i,
              blok: blok
            }, null, 8, ["blok"]))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["image", "no-close", "class"]))
}
}

})